import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import Markdown from 'react-markdown';

import { MARKDOWN_REMARK_PLUGINS } from '@/constants/markdown.constants';
import ReportsTemplateSectionTitle from '@/features/ReportsTemplateSectionTitle/ReportsTemplateSectionTitle';

import type { ReportInsightsDTO } from '../../ReportsTemplate.types';
import useStyles from './ReportsPages.styles';

const ReportsPageSocInsights = ({
  insights
}: {
  insights: ReportInsightsDTO;
}) => {
  const { classes } = useStyles();
  const [breakBody1, setBreakBody1] = useState<boolean>(false);
  const [breakBody2, setBreakBody2] = useState<boolean>(false);
  const body1Ref = useRef<HTMLDivElement>(null);
  const body2Ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const maxColumnHeight = 375;
    if (body1Ref.current) {
      const scrollHeight1 = body1Ref.current.scrollHeight;
      setBreakBody1(scrollHeight1 > maxColumnHeight);
    }
    if (body2Ref.current) {
      const scrollHeight2 = body2Ref.current.scrollHeight;
      setBreakBody2(scrollHeight2 > maxColumnHeight);
    }
  }, []);

  return (
    <div className={classes.reportsPageContainer}>
      <div className={classes.insightsTextContainer}>
        <ReportsTemplateSectionTitle>
          SOC OPERATIONS INSIGHTS
        </ReportsTemplateSectionTitle>
        <Box
          style={{ columnCount: breakBody1 ? 2 : '' }}
          ref={body1Ref}
          className={classes.insightsText}
          data-testid="soc-insights-body-1"
        >
          {insights?.body_1 && (
            <Markdown
              disallowedElements={['img']}
              remarkPlugins={MARKDOWN_REMARK_PLUGINS}
              unwrapDisallowed
            >
              {insights?.body_1 || 'No insights available.'}
            </Markdown>
          )}
        </Box>
      </div>
      <div className={classes.insightsTextContainer}>
        <ReportsTemplateSectionTitle>
          SOC PERSPECTIVE - TRENDS AND OBSERVATIONS
        </ReportsTemplateSectionTitle>
        <Box
          data-testid="soc-insights-body-2"
          style={{ columnCount: breakBody2 ? 2 : '' }}
          ref={body2Ref}
          className={classes.insightsText}
        >
          {insights?.body_2 && (
            <Markdown
              disallowedElements={['img']}
              remarkPlugins={MARKDOWN_REMARK_PLUGINS}
              unwrapDisallowed
            >
              {insights?.body_2 || 'No insights available.'}
            </Markdown>
          )}
        </Box>
      </div>
    </div>
  );
};
export default ReportsPageSocInsights;
